import { Injectable } from '@angular/core';
declare var $;
declare var INSPIRO;

@Injectable({
  providedIn: 'root'
})
export class PoloHelper {
//   Settings = {
//     isMobile: Events.browser.isMobile,
//     submenuLight: $header.hasClass("submenu-light") == true ? true : false,
//     headerHasDarkClass: $header.hasClass("dark") == true ? true : false,
//     headerDarkClassRemoved: false,
//     sliderDarkClass: false,
//     menuIsOpen: false,
//     menuOverlayOpened: false,
// };
Settings: any = {
  headerDarkClassRemoved: false,
  sliderDarkClass: false,
  menuIsOpen: false,
  menuOverlayOpened: false,
};
  constructor() { }

  documentReadyFunctions(){
    INSPIRO.core.functions();
    INSPIRO.header.functions();
    INSPIRO.slider.functions();
    INSPIRO.widgets.functions();
    INSPIRO.elements.functions();
  }
  rowReadyFunctions(){
    INSPIRO.slider.functions();
  }
  documentScrollFunctions(){
    // this.stickyHeader();
    INSPIRO.core.scrollTop();
    INSPIRO.header.dotsMenu();
  }
  documentResizeFunctions(){
    INSPIRO.header.logoStatus();
    // this.stickyHeader();
    INSPIRO.header.mainMenuResponsiveShow();
  }
//   stickyHeader() {
//     let $header = $("#header");

//     //Check if header exist
//     if ($header.length > 0) {
//       let $headerOffsetTop = $header.offset().top;
//       INSPIRO.header.stickyHeader($header,$headerOffsetTop);

//         }

// }
}
